import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { useNavigate } from 'react-router-dom';
import { columnsServerlessProject } from './type';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import PATH_PAGE from '@/router/path';

type Props = {
  data: columnsServerlessProject[] | [];
  isLoading?: boolean;
};
const ServerlessProjectsTable = ({ data, isLoading }: Props) => {
  const navigate = useNavigate();
  const { orgId, workspaceId } = useParamWorkspaceId();
  return (
    <div className="">
      <DataTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        persistPageSize={true}
        pageSizeStorageKey={`serverless-projects-page-size-${workspaceId}`}
        onClickRow={(row) => {
          navigate(PATH_PAGE.dashboard.serverlessGPU.byId(orgId, workspaceId, row.original.projectId).overview);
        }}
      />
    </div>
  );
};

export default ServerlessProjectsTable;
